import { useCallback } from 'react';
import CommonTableRow from './commonTableRow';
import CustomTable from './customTable';
import { MEMBERS_REDUCER_KEYS } from '../../../containers/browsingHistory/browsingHistoryReducer';

const headCells = [
  { id: 'searchedAt', label: '日時', sortable: true },
  { id: 'margeText', label: 'ページタイトル' },
];

export default function OneclickTable(props) {
  const {
    data,
    getApiDataFromListApi,
    isSP,
    handleOpenModal = null,
  } = props;
  const oneclickTablelimit = localStorage.getItem('oneclickTablelimit') ? localStorage.getItem('oneclickTablelimit') : 20;
  const setOneclickTablelimit = useCallback((current) => {
    localStorage.setItem('oneclickTablelimit', current);
  }, []);
  return (
    <CustomTable
      hideHeader={isSP}
      title="ワンクリック検索条件履歴"
      headCells={headCells}
      total={data.total}
      list={data.conditions}
      rowRender={(list) => list.map((row, i) => (<CommonTableRow
        key={String(i)}
        date={row.searchedAt}
        title={row.margeText}
        url={row.url}
      />))}
      onPageChange={(pageInfo) => {
        getApiDataFromListApi(MEMBERS_REDUCER_KEYS.oneclickSearchConditions, pageInfo);
      }}
      divider
      contentHeight={(isSP || handleOpenModal === null) ? null : 130}
      propLimit={oneclickTablelimit}
      setPropLimit={setOneclickTablelimit}
      isNoSlice
      handleOpenModal={handleOpenModal}
    />
  );
}
